import { combineReducers } from "redux";
import ContentRequestContainer from "./containers/ContentRequestContainer";
import tabsReducer from './reducers/tabsReducers';
import contentRequestStateReducer from './reducers/contentRequestStates';
import contentRequestAccordianReducers from './reducers/contentRequestAccordianState';
import ContentRequestCreateContainer from './containers/ContentRequestCreateContainer';
import ContentRequestDetail from "./containers/ContentRequestDetail";
import contentRequestCreator from "./reducers/contentRequestCreateReducer";
import contentRequestReducer from "../content-request/reducers/contentRequestReducer";
import ContentReceivedRequestLandingContainer from './containers/ContentReceivedRequestLanding';
import contentRequestCreateReducer from "./reducers/contentRequestCreateReducer";
import addTestDetail from "./components/AddTestDetail";

const components = { ContentRequestContainer, ContentRequestCreateContainer,ContentRequestDetail,  ContentReceivedRequestLandingContainer, addTestDetail };

const reducers = combineReducers({
  tabData: tabsReducer,
  contentRequestData: contentRequestStateReducer,
  contentRequestAccordianData: contentRequestAccordianReducers,
  contentRequestCreateReducer,
  contentRequestReducer: contentRequestReducer
});

export { components, reducers };
